/* eslint-disable react/jsx-props-no-spreading */
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import i18n from 'i18next';

import { createIconComponent } from 'uikit/icons';
import { MenuItem } from 'uikit/menus';
import { Typo } from 'uikit/content';

import styles from '../styles/menuItems.module.scss';

export default (items) =>
  items.map(
    ({ className, icon, iconClassName, isDisabled, isLink, key, onClick, route, textColor }) => {
      const Element = isLink ? Link : Fragment;

      return (
        <MenuItem
          className={classnames(styles.element, className)}
          key={key}
          isDisabled={isDisabled}
          onClick={!isDisabled ? onClick : null}
        >
          <Element {...(isLink && { tabIndex: -1, to: route })}>
            {icon && <div className={iconClassName}>{createIconComponent({ icon, size: 18 })}</div>}
            <Typo className={styles.text} color={textColor || 'primary'} variant="b01">
              {i18n.t(key)}
            </Typo>
          </Element>
        </MenuItem>
      );
    },
  );
